import styled from "styled-components";
import { Card } from "top-component-library";
import SelectInput from "top-component-library/form-inputs/SelectInput";

export const AlertCardContainer = styled(Card)`
  width: 100%;
`;

// Shared container for each wizard step (recipient / alert source / custom alerts / copy / confirm).
export const StepContainer = styled.div`
  max-width: 400px;
  margin-right: auto;
  margin-left: auto;
`;

export const StationInput = styled(SelectInput)`
  width: 100%;
`;

export const PresetPreview = styled.div`
  margin-top: 16px;
`;
